<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">

    <sidebar></sidebar>
    <div style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5">
      <div v-show="Isblur" class="splash"></div>

      <div class="card card-body card-panel-box border-0" style="    margin: 1vw .9vw;">
        <div class="col-lg-12">
          <div class="card card-body card-panel-box border-0" style="background-color:unset;">
            <div class="row d-flex justify-content-start">
              <div class="d-flex justify-content-between flex-row w-100">
                <h2 style="font-size: 1.2vw !important;width: 12vw;"> پست های سازمانی</h2>
                <div class="d-flex changer">
                  <p>
                    نمودار
                  </p>
                  <router-link to="/pishkhan/Organization/list">
                    جدول
                  </router-link>
                </div>
              </div>
              <hr class="mb-3">

              <div id="svg-tree"></div>



           </div>
              </div>
            </div>

          </div>
        </div>
      </div>

  <!-- Jobs -->



</template>

<script>
import Splash from "@/components/Splash/Splash";
import Sidebar from "@/components/Sidebar/Sidebar";
import router from "@/router";
import {useToast} from "vue-toastification";
import vSelect from "vue-select";
const toast = useToast();

export default {
  name: "ListOrganization",
  components: {vSelect, Sidebar, Splash},
  data() {
    return {

      all_items: [],

    }
  },
  methods: {

    fetchAll() {
      this.all_items.length = 0
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/organization/post/chart_mode`, requestOptions)
          .then(response => response.json())
          .then(result => {
            // داده‌ها را از سمت سرور دریافت کنید

            const data = JSON.parse(result.treeData);
            const options = {
              contentKey: 'data',
              width: 1500,
              height: 600,
              nodeWidth: 150,
              nodeHeight: 50,
              fontColor: '#fff',
              borderColor: '#222',
              childrenSpacing: 50,
              siblingSpacing: 20,
              direction: 'top',
              enableExpandCollapse: true,
              nodeTemplate: (content) =>
                  `<div style='background: #3742FA;display: flex;flex-direction: column;gap: 10px;justify-content: center;align-items: center;height: 100%;'>
                <div style="font-weight: bold; font-family: Shabnam; font-size: 10px">${content && content.name}</div>
            </div>`,
              canvasStyle: 'border: 1px solid black;background: #f6f6f6; border-radius: 0.5vw; width: 80vw',
              enableToolbar: true,
            };

            const tree = new ApexTree(document.getElementById('svg-tree'), options);
            tree.render(data);

          })
          .catch();
    },

  },
  mounted() {
    this.fetchAll()

  },

}
</script>

<style scoped>
label {
  width: 100%;
  text-align: right;
}

table {
  background-color: white !important;
}


img {
  cursor: pointer;
}

tr {
  background-color: #ffff !important;
}
.changer{
  background-color: #AFAFAF;
  height: 2vw;
  border-radius: 1vw;
  width: 10vw;
  margin-bottom: 5vw;
  justify-content: space-evenly;
  &>p:nth-child(1){
    width: 11vw;
    height: 2vw;
    background-color: #3742FA;
    color: #fff;
    transform: translateX(.9vw);
    border-radius: 1vw;
  }
  &>p:nth-child(2){
    margin-left: 1vw;
  }  &>p {
       cursor: pointer;
       font-size: 1vw;
     }
  &>a{
    color: black;
    text-decoration: none;
    margin-left: .9vw;
  }
}
</style>